import React, { useEffect, useState } from 'react'
import { styled } from '@material-ui/core/styles'
import { Grid, CircularProgress, Typography } from '@material-ui/core'
import { useFormikContext } from 'formik'
import { stringify as stringifyQuery } from 'query-string'
import { useDebounce } from 'use-debounce'

import displayAllowedAgreement from 'src/util/displayAllowedAgreement'
import { apiUrl } from 'src/config'

import { Trans } from 'react-i18next'

import { TextInput, CheckboxInput, DoublerInput } from '@ /amazon'

import { AgreementModalButton, Link, FormBlock, FormSection } from 'components'

const StyledCheckbox = styled(({ ...props }) => <CheckboxInput {...props} />)({
  '& label': {
    alignItems: 'flex-start',

    '& .MuiCheckbox-root': {
      paddingTop: 0,
    },
  },
  marginBottom: '16px',
})

export const agreementLabel = (
  <Trans i18nKey="formFields:allowedAgreement.label">
    <AgreementModalButton type="airbnbAssignment" useLink />
  </Trans>
)

const ProxyCheckboxLabel = (
  <Trans i18nKey="formFields:allowedProxy.label">
    <AgreementModalButton type="proxyAgreement" useLink />
  </Trans>
)

// TODO: link  voor uitloggen toevoegen
// TODO: paragraph is nu genest in een andere paragraph
const description = null /*(
  <>
    <Typography variant="body1">
      Heb je al een eerder een claim ingediend bij  ? Klik dan{' '}
      <Link to="airbnbDashboard">hier om in te loggen</Link>
    </Typography>
  </>
)
*/

export const createHouseNumber = (houseNumber, houseNumberAddition) => {
  if (!houseNumberAddition || houseNumberAddition.trim() === '') {
    return houseNumber.trim()
  }
  // check if starts with letter
  if (houseNumberAddition.trim().match(/^[a-zA-Z]/)) {
    return houseNumber.trim() + houseNumberAddition.trim()
  } else {
    return houseNumber.trim() + '-' + houseNumberAddition.trim()
  }
}
const fetchAddress = async (zipcode, houseNumber, houseNumberAddition) => {
  const query = stringifyQuery({ zipcode, houseNumber, houseNumberAddition })
  const result = await fetch(`${apiUrl}/zipcodeCheck?${query}`)
  return result.json()
}
const AddressInput = () => {
  const { values, setFieldValue } = useFormikContext()
  const [loading, setLoading] = useState()
  const [errorCode, setErrorCode] = useState()
  const [edittable, setEdittable] = useState()
  const [zipcode] = useDebounce(values.zipcode, 1000)
  const [houseNumber] = useDebounce(values.houseNumberInput, 1000)

  const nonDebouncedZipcode = values.zipcode
  const nonDebouncedHouseNumber = values.houseNumberInput

  const isUpToDate =
    (zipcode === nonDebouncedZipcode &&
      houseNumber === nonDebouncedHouseNumber) ||
    edittable

  useEffect(() => {
    if (edittable) {
      return
    }
    let isCurrent = true
    setLoading(true)
    setErrorCode()
    setFieldValue('street', '')
    setFieldValue('city', '')
    if (!zipcode || !houseNumber) {
      return
    }
    // your business logic around when to fetch goes here.
    if (zipcode.trim() !== '' && houseNumber.trim() !== '') {
      fetchAddress(zipcode, houseNumber).then((response) => {
        if (!!isCurrent) {
          switch (response.statusCode) {
            case 200:
              const address = response.result
              // prevent setting old values
              setFieldValue('street', address.street)
              setFieldValue('city', address.city)
              setLoading(false)
              break
            default:
              setErrorCode(response.statusCode)
              setLoading(false)
          }
        }
      })
    }
    return () => {
      isCurrent = false
    }
  }, [zipcode, houseNumber, setFieldValue, setLoading, edittable])

  useEffect(() => {
    if (
      nonDebouncedHouseNumber &&
      typeof values.houseNumberAddition !== 'undefined'
    ) {
      setFieldValue(
        'houseNumber',
        createHouseNumber(nonDebouncedHouseNumber, values.houseNumberAddition),
      )
    }
  }, [setFieldValue, nonDebouncedHouseNumber, values.houseNumberAddition])

  if (
    !nonDebouncedZipcode ||
    !nonDebouncedHouseNumber ||
    nonDebouncedZipcode.trim() === '' ||
    nonDebouncedHouseNumber.trim() === ''
  ) {
    return null
  }

  if (loading || !isUpToDate) {
    return <CircularProgress />
  }

  if (!edittable && !errorCode) {
    return (
      <Grid item xs={12}>
        <Typography variant="body1">
          Adres (<Link onClick={() => setEdittable(true)}>aanpassen</Link>)
        </Typography>
        <Typography variant="body1">
          {values.street} {values.houseNumber},{' '}
          {values.zipcode.trim().toUpperCase()} {values.city}
        </Typography>
        {/* <Typography variant="body1">
          {values.zipcode} {values.city}
        </Typography> */}
      </Grid>
    )
  }

  return (
    <>
      {(errorCode === 404 || errorCode === 400) && (
        <Grid item xs={12}>
          We konden jouw combinatie van postcode en huisnummer niet vinden.
          Klopt deze wél? Vul dan je straatnaam en woonplaats in.
        </Grid>
      )}
      <Grid item xs={12} sm={6}>
        <TextInput name="street" />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextInput name="city" />
      </Grid>
    </>
  )
}

const ContactDetails = ({ isAuthenticated, promoCode }) => {
  return (
    <FormBlock description={description}>
      <FormSection>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextInput name="fullName" transKey="airbnbFullName" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextInput name="email" disabled={isAuthenticated} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextInput name="phone" />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextInput
              name="zipcode"
              inputProps={{ style: { textTransform: 'uppercase' } }}
            />
          </Grid>
          <Grid item xs={6} sm={4}>
            <TextInput
              name="houseNumberInput"
              transKey="houseNumber"
              autoComplete="houseNumber"
            />
          </Grid>
          <Grid item xs={6} sm={4}>
            <TextInput
              name="houseNumberAddition"
              autoComplete="houseNumberAddition"
            />
          </Grid>
          <AddressInput />
        </Grid>
      </FormSection>
      <FormSection my={0}>
        {__BUILDFOR__ === ' ' && (
          <StyledCheckbox name="allowedRelatedActionsMail" />
        )}
        <StyledCheckbox
          name="allowedPrivacy"
          label={
            <>
              Ik ga akkoord met de{' '}
              <Link to="privacyDeclaration" target="_blank">
                privacyverklaring
              </Link>{' '}
              {__BUILDFOR__ === ' ' && (
                <>
                  en{' '}
                  <Link to="termsAndConditions" target="_blank">
                    algemene (gebruikers)voorwaarden
                  </Link>
                  .
                </>
              )}
            </>
          }
        />
        {__BUILDFOR__ === ' ' && (
          <DoublerInput name="allowedGeneralTerms" setFrom="allowedPrivacy" />
        )}
      </FormSection>
      <FormSection
        my={0}
        mt={[0, 2]}
        mb={4}
        title={
          displayAllowedAgreement(promoCode) ? (
            <Trans i18nKey="formMessages:agreementHeader" />
          ) : (
            'Volmacht'
          )
        }
        description={
          displayAllowedAgreement(promoCode) && (
            <Trans i18nKey="formMessages:allowedAgreementExplainer" />
          )
        }
      >
        {displayAllowedAgreement(promoCode) && (
          <StyledCheckbox
            name="allowedAgreement"
            label={agreementLabel}
            fieldType="checkbox"
          />
        )}
        <StyledCheckbox
          name="allowedProxy"
          label={ProxyCheckboxLabel}
          fieldType="checkbox"
          style={{ marginBottom: '0' }}
        />
      </FormSection>
    </FormBlock>
  )
}

export default ContactDetails
